export const associationModalStyles = {
  paper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '16px 16px 0 0',
    width: '100%',
    maxWidth: '100%',
  },
  container: {
    bgcolor: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    pb: 3,
    pt: 2,
    px: 2,
    borderRadius: '16px 16px 0 0',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 1,
  },
  title: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 20,
    color: 'rgba(0,0,0,0.87)',
    lineHeight: 1.6,
    letterSpacing: '0.15px',
    flex: 1,
  },
  closeButton: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    flexShrink: 0,
  },
  linkedSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  linkedText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: 'rgba(0,0,0,0.87)',
    lineHeight: 1.5,
    letterSpacing: '0.15px',
  },
  panNumberBold: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 700,
    fontSize: 16,
    color: 'rgba(0,0,0,0.87)',
    lineHeight: 1.5,
  },
  firmsList: {
    listStyleType: 'disc',
    margin: 0,
    paddingLeft: '21px',
  },
  firmsListItem: {
    display: 'list-item',
    color: 'rgba(0,0,0,0.6)',
  },
  firmsListText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0,0,0,0.6)',
    lineHeight: 1.43,
    letterSpacing: '0.17px',
  },
  bankSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  bankSectionMessage: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 16,
    color: 'rgba(0,0,0,0.87)',
    lineHeight: 1.5,
    letterSpacing: '0.15px',
  },
  bankCard: {
    bgcolor: '#f5f5f5',
    borderRadius: '12px',
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  bankCardRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  bankCardLabel: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0,0,0,0.6)',
    lineHeight: 1.5,
    letterSpacing: '0.15px',
    flex: 1,
    minWidth: 0,
  },
  bankCardValue: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    color: 'rgba(0,0,0,0.87)',
    lineHeight: 1.5,
    letterSpacing: '0.15px',
    flex: 1,
    minWidth: 0,
    textAlign: 'right',
  },
};